//// 中部导航 固定
// 获取导航栏和 Banner 的元素
const navbar = document.getElementById("memorialday-navbar");

const banner = document.getElementById("sf__slideshow-template--20169039577145__slider_TT4T9B");

// 获取 Banner 的高度
let bannerHeight = banner != null ? banner.offsetHeight : 0;

// 获取所有菜单项和内容区块
const menuItems = document.querySelectorAll(".navbar-wrap a");
const sections = document.querySelectorAll(".product-display-section");

if(navbar != null){
    // 监听滚动事件
    window.onscroll = function() {
        let currentSection = "";
        
        if (window.scrollY > bannerHeight) {
            navbar.classList.add("fixed");
        } else {
            navbar.classList.remove("fixed");
        }

        // 检查页面滚动位置，找到在视口中的内容区域
        sections.forEach(section => {
            const sectionTop = section.offsetTop - 70; // 偏移量，确保滚动到中心附近
            if (window.scrollY >= sectionTop) {
                currentSection = section.getAttribute("id");
            }
        });

        // 更新菜单项的活动状态
        menuItems.forEach(menu => {
            menu.classList.remove("active");
            if (menu.getAttribute("href") === "#" + currentSection) {
                menu.classList.add("active");

                const targetMenuItem = menu;
                const menuOffset = targetMenuItem.offsetLeft; // 获取目标菜单项的水平位置
                navbar.scrollTo({
                left: menuOffset-10, // 滚动到该菜单项
                behavior: 'smooth' // 平滑滚动
                });
            }
        });
    };
}

const timeCountdown = document.getElementById('time-countdown');
if(timeCountdown != null){
    const setDate = timeCountdown.getAttribute('data-event-date');
    //date countdown
    const countdownDate = new Date(setDate).getTime();
    if(!isNaN(countdownDate)){
        // 更新倒计时函数
        function updateCountdown() {
            const now = new Date().getTime();
            const distance = countdownDate - now;

            // 计算天、小时、分钟和秒
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // 在页面上显示结果
            document.querySelector(".time-countdown-day").innerHTML = (days/10)>=1 ? `<span>${days}</span>` : `<span>0${days}</span>`;
            document.querySelector(".time-countdown-hour").innerHTML = (hours/10)>=1 ?  `<span>${hours}</span>` : `<span>0${hours}</span>`;
            document.querySelector(".time-countdown-min").innerHTML = (minutes/10)>=1 ?  `<span>${minutes}</span>` : `<span>0${minutes}</span>`;
            document.querySelector(".time-countdown-sec").innerHTML = (seconds/10)>=1 ?  `<span>${seconds}</span>` : `<span>0${seconds}</span>`;

            // 如果倒计时结束
            if (distance < 0) {
                clearInterval(countdownInterval);
                document.querySelector(".time-countdown-content").innerHTML = " ";
            }
        }
        // 每秒更新一次倒计时
        const countdownInterval = setInterval(updateCountdown, 1000);
        updateCountdown();  // 立即调用一次
    }
}

//TAB 切换
const tabItems = document.querySelectorAll(".product-section-tabs a.tab-item");
tabItems.forEach(tabItem => {
    tabItem.addEventListener("click", function(event) {
        event.preventDefault(); // 阻止默认链接点击行为

        //移除所有 tab-item 的 active 类
        tabItems.forEach(item => item.classList.remove("active"));
        const contentSections = document.querySelectorAll(".product-section-tabs-content");
        contentSections.forEach(section => section.classList.remove("active"));

        //当前点击的 tab-item 加入 active 类
        this.classList.add("active");    
        const targetId = tabItem.getAttribute("data-content-class");
        const targetSection = document.querySelector("."+targetId);
        if (targetSection) {
            targetSection.classList.add("active");
            // 目标内容从右到左滑入
            targetSection.style.transform = "translateX(100%)";
            targetSection.style.transition = "transform 0.6s ease";
            requestAnimationFrame(() => {
                targetSection.style.transform = "translateX(0)";
            });
        }
    });
});

const customSecTabs = document.querySelectorAll('.product-section-tabs a.tab-item');
const container = document.getElementById('tabContentContainer');
let currentIndex = 0;
let startX = 0, currentX = 0, isDragging = false;

// --- 点击切换 ---
customSecTabs.forEach(tab => {
    tab.addEventListener('click', () => {
        currentIndex = parseInt(tab.dataset.index);
        updateTabs();
    });
});
function updateTabs() {
    customSecTabs.forEach(t => t.classList.remove('active'));
    customSecTabs[currentIndex].classList.add('active');
    container.style.transform = `translateX(-${currentIndex * 100}%)`;
}

//Special sale 变体切换
function specialProductSelectChange(ele) {
    console.log("special changed.");
    var selectedOption = ele.options[ele.selectedIndex];
    
    //价格变化
    let optionPrice = selectedOption.getAttribute("data-price");
    let optionOldPrice = selectedOption.getAttribute("data-old-price");
    var priceContent = optionPrice + '<span class="old-price">' + optionOldPrice + '</span>';
    var nextPriceElement = ele.nextElementSibling;
    nextPriceElement.innerHTML = priceContent;

    //差价信息变化        
    var count_off = parseFloat(optionOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
    var countOffStr = optionPrice.charAt(0)+count_off + ' OFF';
    ele.parentElement.previousElementSibling.previousElementSibling.children[1].innerText = countOffStr;

    //图片变化
    if(selectedOption.getAttribute("data-image-url") != ""){
        var imgEle = ele.parentElement.previousElementSibling;
        imgEle.setAttribute("src",selectedOption.getAttribute("data-image-url"));
    }

    //选中
    selectedOption.setAttribute("selected",true);
}


//production list 变体切换 百分比差价
function productSelectChange(ele) {
    console.log("changed.");
    var selectedOption = ele.options[ele.selectedIndex];
    
    //价格变化
    let optionPrice = selectedOption.getAttribute("data-price");
    let optionOldPrice = selectedOption.getAttribute("data-old-price");
    var priceContent = optionPrice + '<span class="old-price">' + optionOldPrice + '</span>';
    var nextPriceElement = ele.nextElementSibling;
    nextPriceElement.innerHTML = priceContent;

    //差价信息变化 
    optionOldPrice = parseFloat(optionOldPrice.replace(/[^\d\.]/g,''));
    optionPrice = parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    if(optionOldPrice>0 && optionOldPrice>optionPrice){
        var percentStr = Math.round(((optionOldPrice-optionPrice)/optionOldPrice)*100);
        ele.parentElement.previousElementSibling.previousElementSibling.previousElementSibling.children[0].children[0].innerText = percentStr;
    }else{
        ele.parentElement.previousElementSibling.previousElementSibling.previousElementSibling.children[0].children[0].innerText = '';
    }

    //图片变化
    if(selectedOption.getAttribute("data-image-url") != ""){
        var imgEle = ele.parentElement.previousElementSibling;
        imgEle.setAttribute("src",selectedOption.getAttribute("data-image-url"));
    }

    //选中
    selectedOption.setAttribute("selected",true);

    //添加到购物车按钮的变体ID变化
    let optionId = selectedOption.getAttribute("data-id");
    var hiddenVariantInput = ele.parentElement.nextElementSibling.children[0].children[0];
    hiddenVariantInput.value = optionId;

    var addToCartBtnEl = ele.parentElement.nextElementSibling.children[0].children[1];
    addToCartBtnEl.setAttribute("data-variant-id", optionId);
}

//production list 变体切换 普通差价
function productSelectChangeDiff(ele){
  console.log("changed.");
    var selectedOption = ele.options[ele.selectedIndex];
    
    //价格变化
    let optionPrice = selectedOption.getAttribute("data-price");
    let optionOldPrice = selectedOption.getAttribute("data-old-price");
    var priceContent = optionPrice + '<span class="old-price">' + optionOldPrice + '</span>';
    var nextPriceElement = ele.nextElementSibling;
    nextPriceElement.innerHTML = priceContent;

    //差价信息变化        
    var count_off = parseFloat(optionOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(optionPrice.replace(/[^\d\.]/g,''));
    //count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
    count_off = count_off<0?0:Math.round(count_off);
    var countOffStr = optionPrice.charAt(0) + count_off;
    ele.parentElement.previousElementSibling.previousElementSibling.previousElementSibling.children[0].children[0].innerText = countOffStr;

    //图片变化
    if(selectedOption.getAttribute("data-image-url") != ""){
        var imgEle = ele.parentElement.previousElementSibling;
        imgEle.setAttribute("src",selectedOption.getAttribute("data-image-url"));
    }

    //选中
    selectedOption.setAttribute("selected",true);

    //添加到购物车按钮的变体ID变化
    let optionId = selectedOption.getAttribute("data-id");
    var hiddenVariantInput = ele.parentElement.nextElementSibling.children[0].children[0];
    hiddenVariantInput.value = optionId;
    var addToCartBtnEl = ele.parentElement.nextElementSibling.children[0].children[1];
    addToCartBtnEl.setAttribute("data-variant-id", optionId);
}

// 获取所有special sale First 变体项
const specialVariantItems = document.querySelectorAll(".product-options .label-item-first");
specialVariantItems.forEach(vairantItem => {
    vairantItem.onclick = function() {
        //所有同级节点 移除 active
        document.querySelector(".label-item-first.active").classList.remove('active');

        //当前节点 加入 active
        if(!vairantItem.classList.contains('active')){
            vairantItem.classList.add('active');
        }

        //价格变化
        let variantPrice = vairantItem.getAttribute("data-price");
        let variantOldPrice = vairantItem.getAttribute("data-old-price");
        var priceContent = variantPrice + '<span class="old-price">' + variantOldPrice + '</span>';
        document.querySelector(".special-first-price").innerHTML = priceContent;

        //差价信息变化        
        var count_off = parseFloat(variantOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(variantPrice.replace(/[^\d\.]/g,''));
        count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
        var countOffStr = variantPrice.charAt(0)+count_off+' OFF';
        document.querySelector(".special-image-first").parentElement.previousElementSibling.children[1].innerText = countOffStr;

        //图片变化
        if(vairantItem.getAttribute("data-image-url") != ""){
            document.querySelector(".special-image-first").setAttribute("src",vairantItem.getAttribute("data-image-url"));
        }
    };
});
//special sale first BuyNow
function buySpecialFirst(){
    var choosenItem = document.querySelector(".label-item-first.active");
    var choosenItemId = choosenItem.getAttribute("data-id");
    window.location.href = '/cart/'+choosenItemId+':1';
}

// 获取所有special sale First 变体项
const specialVariantSecondItems = document.querySelectorAll(".product-options .label-item-second");
specialVariantSecondItems.forEach(vairantItem => {
    vairantItem.onclick = function() {
        //所有同级节点 移除 active
        document.querySelector(".label-item-second.active").classList.remove('active');

        //当前节点 加入 active
        if(!vairantItem.classList.contains('active')){
            vairantItem.classList.add('active');
        }

        //价格变化
        let variantPrice = vairantItem.getAttribute("data-price");
        let variantOldPrice = vairantItem.getAttribute("data-old-price");
        var priceContent = variantPrice + '<span class="old-price">' + variantOldPrice + '</span>';
        document.querySelector(".special-second-price").innerHTML = priceContent;

        //差价信息变化        
        var count_off = parseFloat(variantOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(variantPrice.replace(/[^\d\.]/g,''));
        count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
        var countOffStr = variantPrice.charAt(0)+count_off+' OFF';
        document.querySelector(".special-image-second").parentElement.previousElementSibling.children[1].innerText = countOffStr;

        //图片变化
        if(vairantItem.getAttribute("data-image-url") != ""){
            document.querySelector(".special-image-second").setAttribute("src",vairantItem.getAttribute("data-image-url"));
        }
    };
});
//special sale Second BuyNow
function buySpecialSecond(){
    var choosenItem = document.querySelector(".label-item-second.active");
    var choosenItemId = choosenItem.getAttribute("data-id");
    window.location.href = '/cart/'+choosenItemId+':1';
}

// 获取所有special sale Third 变体项
const specialVariantThirdItems = document.querySelectorAll(".product-options .label-item-third");
specialVariantThirdItems.forEach(vairantItem => {
    vairantItem.onclick = function() {
        //所有同级节点 移除 active
        document.querySelector(".label-item-third.active").classList.remove('active');

        //当前节点 加入 active
        if(!vairantItem.classList.contains('active')){
            vairantItem.classList.add('active');
        }

        //价格变化
        let variantPrice = vairantItem.getAttribute("data-price");
        let variantOldPrice = vairantItem.getAttribute("data-old-price");
        var priceContent = variantPrice + '<span class="old-price">' + variantOldPrice + '</span>';
        document.querySelector(".special-third-price").innerHTML = priceContent;

        //差价信息变化        
        var count_off = parseFloat(variantOldPrice.replace(/[^\d\.]/g,'')) - parseFloat(variantPrice.replace(/[^\d\.]/g,''));
        count_off = count_off<0?0.00:Math.round(count_off * 100) / 100;
        var countOffStr = variantPrice.charAt(0)+count_off+' OFF';
        document.querySelector(".special-image-third").parentElement.previousElementSibling.children[1].innerText = countOffStr;

        //图片变化
        if(vairantItem.getAttribute("data-image-url") != ""){
            document.querySelector(".special-image-third").setAttribute("src",vairantItem.getAttribute("data-image-url"));
        }
    };
});
//special sale Third BuyNow
function buySpecialThird(){
    var choosenItem = document.querySelector(".label-item-third.active");
    var choosenItemId = choosenItem.getAttribute("data-id");
    window.location.href = '/cart/'+choosenItemId+':1';
}


function buyNowProductItem(ele) {
    var productSelectEle = ele.parentElement.parentElement.previousElementSibling.children[1];
    var selectedOption = productSelectEle.options[productSelectEle.selectedIndex];
    var choosenItemId = selectedOption.getAttribute("data-id");
    window.location.href = '/cart/'+choosenItemId+':1';
}

function addToCart(buttonEl) {
    const originalText = buttonEl.textContent;
    //buttonEl.textContent = 'Adding ...';
    buttonEl.disabled = true;

    const variantId = buttonEl.getAttribute("data-variant-id");

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    }).then(response => response.json())
    .then(data => {
      console.log('✅ Added to cart:  ' + data.title);
      //buttonEl.textContent = '✅ Added to cart';
      
      Shopify.onCartUpdate();
    })
    .catch((error) => {
      console.error('❌ Failed add:', error);
      //buttonEl.textContent = '❌ Failed add';
    }).finally(() => {
      //buttonEl.textContent = originalText;
      buttonEl.disabled = false;
    });
}

//FAQ
const faqItems = document.querySelectorAll(".faq-item .faq-title");
faqItems.forEach(faqTitle => {
    faqTitle.onclick = function() {
        var nextElement = faqTitle.nextElementSibling;
        if(nextElement.classList.contains('active')){
            nextElement.classList.remove('active');
        }else {
            nextElement.classList.add('active');
        }
    };
});